import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutParents from "./components/AboutParents";
import Services from "./components/Services";
import GetInvolved from "./components/GetInvolved";
import Trustees from "./components/Trustees";
import NotableActivities from "./components/NotableActivities";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import { EditProvider } from "./context/EditContext";
import ActivitiesPage from "./components/ActivitiesPage";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#dad7c9]">
      <Navbar />
      <main>
        <Hero />
        <AboutParents />
        <Services />
        <GetInvolved />
        <Trustees />
        <NotableActivities />
        <ContactSection />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <EditProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/activities" element={<ActivitiesPage />} />
          </Routes>
        </BrowserRouter>
      </EditProvider>
    </div>
  );
}

export default App;
